import {  Transform } from '../4d-objects';
import { from, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import {  Renderer,PlottableReference } from '../renderer'
const Cesium = (<any>window).Cesium


/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
export class WMSTransformRenderer extends Renderer<Transform>{

  constructor(private viewer:any){
    super()
    this._log();
  }

  onAdd(t:Transform, args?:any){

    let me = this;

    var url:string = t['url'] || t.file('WMS')
    var layer = (args ? args.layer : null) || (t['proxyMeta']?t['proxyMeta'].layer_id:null)

    me._log('onAdd',[t, args, url, layer]);

    if(args && args.onInit) { args.onInit(t,{url,layer}); }

    // console.log("xform " + t.id,args);
    // if this is a .redirect file, then the URL is just the WMS endpoint, in which case make the request as if a local file
    if(!url || !layer){

      url = t.file('WMS')

      //me._log('onAdd fetch()',[t,args, url, layer]);

      if(args && args.onStart) { args.onStart(t,{url,layer}); }

      // query WMS info and grab the first layer (note I dont do any othe the other layers yet)
      return from(fetch(url + '&service=wms&request=getcapabilities')
        .then(r => r.text())
        .then(r => {
          var parser = new DOMParser();
          // console.log('%c ## FEATURES ', Constants._red, r );
          var dom = parser.parseFromString(r,'text/xml')
          if(args && args.onProcess) { args.onProcess(t,r); }
          try {
            var layer = dom.getElementsByTagName("Layer")[0]
            var layerName = layer.getElementsByTagName('Name')[0].textContent
            var bb = dom.getElementsByTagName("BoundingBox")[0]
            if(bb){
              t.llng = parseFloat(bb.getAttribute('minx'))
              t.ulng = parseFloat(bb.getAttribute('maxx'))
              t.llat = parseFloat(bb.getAttribute('miny'))
              t.ulat = parseFloat(bb.getAttribute('maxy'))
            }
            me._log('onAdd fetch() result',[r,bb,layerName]);
            return layerName;  
          } catch (error) {
            console.log('#wms_renderer ERROR : ', error, dom, r );
            return null;
          }
          
        })
      ).pipe(concatMap(layer => {
      
        return me.onAdd(t,{layer:layer,url:url})
      }))
    }

    // Otherwise this is old way, which is terrible
    else if(url){
      
      if(document.location.protocol == 'https:' && !url.startsWith('https')) {
        url = t.vasat.config.host + '/proxy/' + t.account.id + '/' + url + (url.indexOf('?') == -1?'?':'&') + 'access_token=' + t.vasat.token;
      }
      //me._log('onAdd url',[t,args, url, layer]);
    } else {
      //me._log('onAdd ??',[t,args, url, layer]);
    }

    if(args && args.onStart) { args.onStart(t,{url,layer}); }

    var config = {
      url : args && args.url ? args.url : url,
      layers : layer,
      getFeatureInfoFormats: [new Cesium.GetFeatureInfoFormat("xml", "text/xml")],
      parameters:{
        transparent:true,
        format:'image/png'
      }
    };

    me._log('onAdd old',config);

    // unfortunately, WebMapServiceImageryProvider nor viewer.imageryLayers have any events or promises that tells us
    // when the layer is ready (apart from initializing the config), the bounding box, tiles loading or anything like that

    var shadedRelief1 = new Cesium.WebMapServiceImageryProvider(config);

    if(args && args.onProcess) { args.onProcess(t,shadedRelief1); }

    var obj = null;

    shadedRelief1.readyPromise.then( res => {

      obj = me.viewer.imageryLayers.addImageryProvider(shadedRelief1);

      if(args && args.onEnd) { args.onEnd(t,obj); }
  
    })
    obj['transform_id'] = t.id
    var pr:PlottableReference = {
      plottable:t,
      object:obj
      
    }
    
    return of(pr)
  
  }
  onRemove(t:Transform,pr:PlottableReference){
    this.viewer.imageryLayers.remove(pr.object)
  }
}
